module.exports = __webpack_public_path__ + "img/FINANCEPR7.3fc7d6ad.png";